<template>
  <v-app>
    <v-overlay :value="isLoading" absolute>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>

    <NavBar v-if="!isLoading"
            :logoPrefeitura="logoPrefeitura"
            :habilitaLinkNotaEletronica="habilitaLinkNotaEletronica"
            :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
            :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"
            :urlCadastroAvulsaPessoaFisica="urlCadastroAvulsaPessoaFisica"
            :urlCadastroAvulsaPessoaJuridica="urlCadastroAvulsaPessoaJuridica"
            :permiteRedefinicaoEmail="permiteRedefinicaoEmail"
            :botaoCardCadastro="botaoCardCadastro"
            :botaoCardEntrar="botaoCardEntrar"
            :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
            :habilitadoCardCadastro="habilitadoCardCadastro"
    />

    <v-main v-if="!isLoading" class="grey lighten-4">
      <router-view
          :bannerTopo="bannerTopo"
          :nomeSistema="nomeSistema"
          :textoBanner="textoBanner"
          :sobreSistema="sobreSistema"
          :endereco="endereco"
          :telefone="telefone"
          :linkMovidesk="linkMovidesk"
          :perguntas="perguntas"
          :itemsLegislacao="itemsLegislacao"

          :permiteRedefinicaoEmail="permiteRedefinicaoEmail"

          :habilitadoCardEntrar="habilitadoCardEntrar"
          :tituloCardEntrar="tituloCardEntrar"
          :textoCardEntrar="textoCardEntrar"
          :botaoCardEntrar="botaoCardEntrar"

          :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
          :tituloCardPrimeiroAcesso="tituloCardPrimeiroAcesso"
          :textoCardPrimeiroAcesso="textoCardPrimeiroAcesso"
          :botaoCardPrimeiroAcesso="botaoCardPrimeiroAcesso"

          :habilitadoCardCadastro="habilitadoCardCadastro"
          :tituloCardCadastro="tituloCardCadastro"
          :textoCardCadastro="textoCardCadastro"
          :botaoCardCadastro="botaoCardCadastro"

          :habilitadoCardPasso1 = "habilitadoCardPasso1"
          :tituloCardPasso1="tituloCardPasso1"
          :textoCardPasso1="textoCardPasso1"

          :habilitadoCardPasso2 = "habilitadoCardPasso2"
          :tituloCardPasso2="tituloCardPasso2"
          :textoCardPasso2="textoCardPasso2"

          :habilitadoCardPasso3 = "habilitadoCardPasso3"
          :tituloCardPasso3="tituloCardPasso3"
          :textoCardPasso3="textoCardPasso3"

          :habilitadoCardPasso4 = "habilitadoCardPasso4"
          :tituloCardPasso4="tituloCardPasso4"
          :textoCardPasso4="textoCardPasso4"

          :canaisAtendimento="canaisAtendimento"
          :habilitadoLinkFaleConosco="habilitadoLinkFaleConosco"

          :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
          :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"

          :urlCadastroAvulsaPessoaFisica="urlCadastroAvulsaPessoaFisica"
          :urlCadastroAvulsaPessoaJuridica="urlCadastroAvulsaPessoaJuridica">

      </router-view>
    </v-main>
    <Footer v-if="!isLoading"
            :logoRodape="logoRodape" :sigla-empresa="siglaEmpresa" :nome-empresa="nomeEmpresa"/>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer";
import EventService from "./services/EventService";
import Hero from "@/components/Hero.vue";

export default {
  name: "App",
  components: {
    Hero,
    NavBar,
    Footer,
  },
  data: () => ({
    isLoading: true,
    bannerTopo: null,
    nomeSistema: "",
    textoBanner: "",
    sobreSistema: "",
    logoPrefeitura: null,
    logoRodape: null,
    siglaEmpresa: "",
    nomeEmpresa: "",
    endereco: "",
    telefone: "",
    linkMovidesk: "",
    perguntas: [],
    itemsLegislacao: null,
    habilitaLinkNotaEletronica: false,

    habilitadoAutenticacaoPessoaFisica: false,
    habilitadoAutenticacaoPessoaJuridica: false,

    urlCadastroAvulsaPessoaFisica: "",
    urlCadastroAvulsaPessoaJuridica: "",

    permiteRedefinicaoEmail: true,

    habilitadoCardEntrar: false,
    tituloCardEntrar: "",
    textoCardEntrar: "",
    botaoCardEntrar: "",

    habilitadoCardPrimeiroAcesso: false,
    tituloCardPrimeiroAcesso: "",
    textoCardPrimeiroAcesso: "",
    botaoCardPrimeiroAcesso: "",

    habilitadoCardCadastro: false,
    tituloCardCadastro: "",
    textoCardCadastro: "",
    botaoCardCadastro: "",

    habilitadoCardPasso1: false,
    tituloCardPasso1:"",
    textoCardPasso1:"",

    habilitadoCardPasso2: false,
    tituloCardPasso2:"",
    textoCardPasso2:"",

    habilitadoCardPasso3: false,
    tituloCardPasso3:"",
    textoCardPasso3:"",

    habilitadoCardPasso4: false,
    tituloCardPasso4:"",
    textoCardPasso4:"",

    canaisAtendimento: "",
    habilitadoLinkFaleConosco: true,
  }),
  created() {
    EventService.getConteudo().then((response) => {
      // cores
      this.$vuetify.theme.themes.light.primary = response.data.corPrimaria;
      this.$vuetify.theme.themes.light.secondary = response.data.corSecundaria;
      // hero
      this.bannerTopo = response.data.imagemBanner;
      this.nomeSistema = response.data.nomeSistemaAvulsa;
      this.textoBanner = response.data.textoBannerNotaAvulsa;
      this.sobreSistema = response.data.textoExplicativoNotaFiscalAvulsa;
      // footer e navbar
      this.logoPrefeitura = response.data.imagemPrefeitura;
      this.logoRodape = response.data.imagemRodape;
      // contato
      this.endereco = response.data.enderecoAtendimento;
      this.telefone = response.data.telefoneAtendimento;
      this.linkMovidesk = response.data.linkFormularioAtendimentoMovidesk;
      // perguntas
      this.perguntas = response.data.listaCategoriaPergunta;
      // legislacao
      this.itemsLegislacao = response.data.listaLegislacao;

      this.siglaEmpresa = response.data.siglaEmpresa;
      this.nomeEmpresa = response.data.nomeEmpresa;

      this.habilitaLinkNotaEletronica = response.data.habilitaLinkNotaEletronica;

      this.permiteRedefinicaoEmail = response.data.permiteRedefinicaoEmail;

      this.habilitadoCardEntrar = response.data.habilitadoCardEntrarAvulsa;
      this.tituloCardEntrar = response.data.tituloCardEntrarAvulsa;
      this.textoCardEntrar = response.data.textoCardEntrarAvulsa;
      this.botaoCardEntrar = response.data.botaoCardEntrarAvulsa;

      this.habilitadoCardPrimeiroAcesso = response.data.habilitadoCardPrimeiroAcessoAvulsa;
      this.tituloCardPrimeiroAcesso = response.data.tituloCardPrimeiroAcessoAvulsa;
      this.textoCardPrimeiroAcesso = response.data.textoCardPrimeiroAcessoAvulsa;
      this.botaoCardPrimeiroAcesso = response.data.botaoCardPrimeiroAcessoAvulsa;

      this.habilitadoCardCadastro = response.data.habilitadoCardCadastroAvulsa;
      this.tituloCardCadastro = response.data.tituloCardCadastroAvulsa;
      this.textoCardCadastro = response.data.textoCardCadastroAvulsa;
      this.botaoCardCadastro = response.data.botaoCardCadastroAvulsa;

      this.habilitadoCardPasso1 = response.data.habilitadoCardPasso1Avulsa;
      this.tituloCardPasso1 = response.data.tituloCardPasso1Avulsa;
      this.textoCardPasso1 = response.data.textoCardPasso1Avulsa;

      this.habilitadoCardPasso2 = response.data.habilitadoCardPasso2Avulsa;
      this.tituloCardPasso2 = response.data.tituloCardPasso2Avulsa;
      this.textoCardPasso2 = response.data.textoCardPasso2Avulsa;

      this.habilitadoCardPasso3 = response.data.habilitadoCardPasso3Avulsa;
      this.tituloCardPasso3 = response.data.tituloCardPasso3Avulsa;
      this.textoCardPasso3 = response.data.textoCardPasso3Avulsa;

      this.habilitadoCardPasso4 = response.data.habilitadoCardPasso4Avulsa;
      this.tituloCardPasso4 = response.data.tituloCardPasso4Avulsa;
      this.textoCardPasso4 = response.data.textoCardPasso4Avulsa;

      this.canaisAtendimento = response.data.canaisAtendimento;
      this.habilitadoLinkFaleConosco=response.data.habilitadoLinkFaleConosco;

      this.habilitadoAutenticacaoPessoaFisica = response.data.habilitadoAutenticacaoPessoaFisica;
      this.habilitadoAutenticacaoPessoaJuridica = response.data.habilitadoAutenticacaoPessoaJuridica;

      this.urlCadastroAvulsaPessoaFisica = response.data.urlCadastroAvulsaPessoaFisica;
      this.urlCadastroAvulsaPessoaJuridica = response.data.urlCadastroAvulsaPessoaJuridica;

      this.isLoading = false;
    });
  },
};
</script>

<style>
</style>
